module.exports = __webpack_public_path__ + "static/media/load_support_img.2f2ba63e.png";